export const metrics = [
  { name: "Opened", value: 0 },
  { name: "Source Category", value: 2 },
  { name: "Media Bias Rating", value: 3 },
];

export const sortOptions = [
  { name: "A - Z", key: 0 },
  { name: "Z - A", key: 1 },
  { name: "Largest to Smallest", key: 2 },
  { name: "Smallest to Largest", key: 3 },
];

export const videos = () => {
  return [
    {
      title: "How to Run a Search",
      id: "913814566",
    },
    { title: "Transparency Tools", id: "913817425" },
    { title: "Productivity Tools ", id: "913818114" },
  ];
};

export const frequencies = [
  { name: "All Time", value: 0 },
  { name: "Last Month", value: 1 },
  { name: "Last Year", value: 2 },
  { name: "Custom Date", value: 3 },
];

export const ITEMS_PER_PAGE = 10;

export const colorArray = [
  "#126ba3",
  "#a3becf",
  "#6e3aa6",
  "#bd6c81",
  "#a10830",
];

export const AcademiaOptions = [
  "Search CORE's research papers",
  "Search Semantic Scholar's research papers",
  "Academia & Scholarly Resources (default)",
];

export const AcademiaOptionsLabels = {
  core: "Search CORE's research papers",
  semantics: "Search Semantic Scholar's research papers",
  academia: "Academia & Scholarly Resources (default)",
};

export const AcademiaLabels = ["core", "semantics", "academia"];

export const AcademiaLabelsDisplay = {
  core: "CORE",
  semantics: "Semantic Scholar",
  academia: "",
};

export const academiaDescription = (label) => {
  if (label === "Academia" || label === "Try This!") return "";
  return `You are now searching ${label} exclusively.`;
};

export const mapCitationData = (data) => {
  const res = {
    numberOfVolumes: data.numberOfVolumes_chr,
    callNumber: data.callNumber_chr,
    rights: data.rights_chr,
    extra: data.extra_chr,
    numPages: data.numPages_chr,
    place: data.place_chr,
    language: data.language_chr,
    volume: data.volume_chr,
    seriesNumber: data.seriesNumber_chr,
    libraryCatalog: data.libraryCatalog_chr,
    archive: data.archive_chr,
    series: data.series_chr,
    archiveLocation: data.archiveLocation_chr,
    publisher: data.publisher_chr,
    title: data.title_chr,
    publicationTitle: data.publicationTitle_chr,
    date: data.date_dtm,
    key: data.citationId_ids,
    version: data.version_chr,
    url: data.url_chr,
    language: data.language_chr,
    accessDate: data.accessDate_dtm,
    shortTitle: data.shortTitle_chr,
    collectionSourceId: data.collectionSourceId_chr,
    userId: data.userId_chr,
    citation: data.citation_chr,
    section: data.section_chr,
    ISSN: data.issN_chr,
    pages: data.pages_chr,
    edition: data.edition_chr,
    itemType: data.itemType_chr,
    author: data.author_chr,
    styles: data.styles_chr,
    citationId: data.citationId_ids,
    abstractNote: data.abstractNote_chr,
    ISBN: data.isbN_chr,
    creators: data.creators,
    // additional
    websiteTitle: data.websiteTitle_chr,
    websiteType: data.websiteType_chr,
    applicationNumber: data.applicationNumber_chr,
    archiveId: data.archiveId_chr,
    artworkMedium: data.artworkMedium_chr,
    artworkSize: data.artworkSize_chr,
    assignee: data.assignee_chr,
    audioFileType: data.audioFileType_chr,
    audioRecordingFormat: data.audioRecordingFormat_chr,
    billNumber: data.billNumber_chr,
    blogTitle: data.blogTitle_chr,
    caseName: data.caseName_chr,
    citationKey: data.citationKey_chr,
    code: data.code_chr,
    codeNumber: data.codeNumber_chr,
    codePages: data.codePages_chr,
    codeVolume: data.codeVolume_chr,
    committee: data.committee_chr,
    company: data.company_chr,
    conferenceName: data.conferenceName_chr,
    country: data.country_chr,
    court: data.court_chr,
    dateDecided: data.dateDecided_dtm,
    dateEnacted: data.dateEnacted_dtm,
    dictionaryTitle: data.dictionaryTitle_chr,
    distributor: data.distributor_chr,
    docketNumber: data.docketNumber_chr,
    documentNumber: data.documentNumber_chr,
    DOI: data.doI_chr,
    encyclopediaTitle: data.encyclopediaTitle_chr,
    episodeNumber: data.episodeNumber_chr,
    filingDate: data.filingDate_dtm,
    firstPage: data.firstPage_chr,
    format: data.format_chr,
    forumTitle: data.forumTitle_chr,
    genre: data.genre_chr,
    history: data.history_chr,
    identifier: data.identifier_chr,
    institution: data.institution_chr,
    interviewMedium: data.interviewMedium_chr,
    issue: data.issue_chr,
    issueDate: data.issueDate_dtm,
    issuingAuthority: data.issuingAuthority_chr,
    journalAbbreviation: data.journalAbbreviation_chr,
    label: data.label_chr,
    legalStatus: data.legalStatus_chr,
    legislativeBody: data.legislativeBody_chr,
    letterType: data.letterType_chr,
    manuscriptType: data.manuscriptType_chr,
    mapType: data.mapType_chr,
    meetingName: data.meetingName_chr,
    nameOfAct: data.nameOfAct_chr,
    network: data.network_chr,
    number: data.number_chr,
    organization: data.organization_chr,
    patentNumber: data.patentNumber_chr,
    postType: data.postType_chr,
    presentationType: data.presentationType_chr,
    priorityNumbers: data.priorityNumbers_chr,
    proceedingsTitle: data.proceedingsTitle_chr,
    programmingLanguage: data.programmingLanguage_chr,
    programTitle: data.programTitle_chr,
    publicLawNumber: data.publicLawNumber_chr,
    references: data.references_chr,
    reporter: data.reporter_chr,
    reporterVolume: data.reporterVolume_chr,
    reportNumber: data.reportNumber_chr,
    reportType: data.reportType_chr,
    repository: data.repository_chr,
    repositoryLocation: data.repositoryLocation_chr,
    runningTime: data.runningTime_chr,
    scale: data.scale_chr,
    seriesText: data.seriesText_chr,
    session: data.session_chr,
    status: data.status_chr,
    subject: data.subject_chr,
    system: data.system_chr,
    thesisType: data.thesisType_chr,
    type: data.type_chr,
    university: data.university_chr,
    versionNumber: data.versionNumber_chr,
    videoRecordingFormat: data.videoRecordingFormat_chr,
    lastUpdatedDateTime: data.lastUpdatedDateTime_dtm,
  };
  return res;
};

export const summaryMessage = `We are generating your article summary. This will take around 20 seconds while we complete two steps. First, we retrieve the full article text directly from the source. Second, we input the text into our pre-trained transformer model to generate the summary as an output. Our transformer model is specifically designed to summarize text, therefore the only data we provide it is the text from the article. Relying on our own summarization pipeline significantly reduces risk of error while keeping your personal data safe.`;

export const articleSummary1 = `We used our own pre-trained transformer model to generate this summary. The only data we use is the text from the article. Relying on our own summarization pipeline significantly reduces risk of error while keeping your personal data safe.`;

export const articleSummary2 = `Generative AI is a new technology and can be prone to errors. Please confirm with the original work and edit as needed by clicking the “Edit” button below.`;

// ----------------

export const customSummaryMessage = `We used our own pre-trained transformer model to generate this summary. Generative AI is a new technology and can be prone to errors. Please confirm with the original work and edit as needed by clicking the “Edit” button below.`;

export const customSummaryLoading = `We're generating your summary using our pre-trained transformer model. This will probably take around 20 seconds.`;

export const customSummary1 = `Paste your text below and we’ll summarize it using our pre-trained transformer model. Our transformer model is specifically designed to summarize text, therefore the only data we provide it is the text you have provided us. We do not use or store any of the content you provide for model training purposes, however, you should not include any personal information as a matter of smart hygiene when using AI products.`;

export const customSummary2 = `Depending on the length of your text, the summarization process could take about 20 seconds.`;

export const mapBookmarkData = (data) => {
  const res = {
    ...data,
    sourceURL: data.sourceUrl_chr,
    sourceName: data.sourceName_chr,
    sourcePublishedDateTime: data.sourcePublishedDateTime_dtm,
    title: data.title_chr,
    collectionSourceId: data.collectionSourceID_ids,
  };

  return res;
};
